<template>
  <v-container>
      <lineGraph :chart-data="data" :options="options"></lineGraph>
  </v-container>
</template>

<script>
import lineGraph from '../developing/line-graph.js'

export default {
    components: {
        lineGraph
    },
    data () {
        return {
            data: { 
                    labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jul', 'Aug'], 
                    datasets: [{
                        label: 'Data One',
                        data: [40, 39, 10, 40, 39, 80, 40]
                        }, {
                        label: 'Data Two', 
                        data: [20,30,50,1,23,45,8]
                        }] 
                    },
            options: {
                tooltips: {
                    
                },
                title: {
                    display: true,
                
                    fontSize: 16
                },
                legend: {
                    display: false,
                    position: 'top',
                    labels: {
                        fontSize: 10
                    },
                },
                scales: {
                    yAxes: [{
                        scaleLabel: {
                            display: true,
                            labelString: 'Time'
                        }
                    }],
                    xAxes: [{
                        scaleLabel: {
                            display: true,
                            labelString: 'Time',
                        },
                        ticks: {
                            display: false
                        }
                    }]
                }
        }
            }
        }
    }
</script>

<style>

</style>